// Currency configuration and utilities
export const CURRENCIES = {
  USD: { symbol: '$', name: 'US Dollar', decimals: 2 },
  GBP: { symbol: '£', name: 'British Pound', decimals: 2 },
  EUR: { symbol: '€', name: 'Euro', decimals: 2 },
  CAD: { symbol: 'C$', name: 'Canadian Dollar', decimals: 2 },
  AUD: { symbol: 'A$', name: 'Australian Dollar', decimals: 2 },
  JPY: { symbol: '¥', name: 'Japanese Yen', decimals: 0 },
  CHF: { symbol: 'CHF', name: 'Swiss Franc', decimals: 2 },
  CNY: { symbol: '¥', name: 'Chinese Yuan', decimals: 2 },
  INR: { symbol: '₹', name: 'Indian Rupee', decimals: 2 }
};

export const DEFAULT_CURRENCY = 'USD';

// Get currency symbol
export const getCurrencySymbol = (currencyCode) => {
  return CURRENCIES[currencyCode]?.symbol || '$';
};

// Get currency name
export const getCurrencyName = (currencyCode) => {
  return CURRENCIES[currencyCode]?.name || 'US Dollar';
};

// Format amount with currency
export const formatCurrency = (amount, currencyCode = DEFAULT_CURRENCY) => {
  const currency = CURRENCIES[currencyCode] || CURRENCIES[DEFAULT_CURRENCY];
  const numericAmount = parseFloat(amount) || 0;
  
  // Handle special formatting for different currencies
  if (currencyCode === 'JPY') {
    return `${currency.symbol}${Math.round(numericAmount).toLocaleString()}`;
  }
  
  return `${currency.symbol}${numericAmount.toLocaleString(undefined, {
    minimumFractionDigits: currency.decimals,
    maximumFractionDigits: currency.decimals
  })}`;
};

// Format amount for input fields (without symbol)
export const formatAmountForInput = (amount, currencyCode = DEFAULT_CURRENCY) => {
  const currency = CURRENCIES[currencyCode] || CURRENCIES[DEFAULT_CURRENCY];
  const numericAmount = parseFloat(amount) || 0;
  
  if (currencyCode === 'JPY') {
    return Math.round(numericAmount).toString();
  }
  
  return numericAmount.toFixed(currency.decimals);
};

// Get all currency options for dropdowns
export const getCurrencyOptions = () => {
  return Object.entries(CURRENCIES).map(([code, config]) => ({
    value: code,
    label: `${config.symbol} ${code} - ${config.name}`,
    symbol: config.symbol,
    name: config.name
  }));
};

// Validate currency code
export const isValidCurrency = (currencyCode) => {
  return Object.keys(CURRENCIES).includes(currencyCode);
};

// Get decimal places for currency
export const getCurrencyDecimals = (currencyCode) => {
  return CURRENCIES[currencyCode]?.decimals || 2;
}; 